import React, { useState } from 'react'
import GIcon from "../GIcon"
import SpinnerIcon from "../../icons/SpinnerIcon"

export function FileMsg({url,mime_type,text,filename: content}:{url:string,mime_type:string,text:string,filename}){
    const [loading, setLoading] = useState(false)

    const handleDownload = (e: React.MouseEvent) => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }

    return (
        <div className='flex flex-col w-40' style={{ direction: "ltr" }} >
            <div className='flex flex-row justify-between items-center gap-2'>
                {loading ? (
                    <div className="mx-auto size-6">
                        <SpinnerIcon  />
                    </div>
                ) : (
                    <a href={url} download={url.split('/').pop() || 'file'} onClick={handleDownload}>
                        <GIcon className='cursor-pointer' name='file_download' />
                    </a>
                )}
                {content}
            </div>
            <div className="text-center">{text}</div>
        </div>
    )
}